/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreatePlatformGcpIamCredentialForm = {
  /**
   * The service account Speakeasy impersonates. Set alone for direct impersonation, or as the hop alongside the wif_* fields.
   */
  impersonateServiceAccount?: string | undefined;
  /**
   * A human-readable name for the credential.
   */
  name: string;
  /**
   * Workload Identity Federation pool ID. Set together with the other wif_* fields.
   */
  wifPoolId?: string | undefined;
  /**
   * GCP project number backing the WIF pool. Set together with the other wif_* fields.
   */
  wifProjectNumber?: string | undefined;
  /**
   * Workload Identity Federation provider ID. Set together with the other wif_* fields.
   */
  wifProviderId?: string | undefined;
};

/** @internal */
export type CreatePlatformGcpIamCredentialForm$Outbound = {
  impersonate_service_account?: string | undefined;
  name: string;
  wif_pool_id?: string | undefined;
  wif_project_number?: string | undefined;
  wif_provider_id?: string | undefined;
};

/** @internal */
export const CreatePlatformGcpIamCredentialForm$outboundSchema: z.ZodMiniType<
  CreatePlatformGcpIamCredentialForm$Outbound,
  CreatePlatformGcpIamCredentialForm
> = z.pipe(
  z.object({
    impersonateServiceAccount: z.optional(z.string()),
    name: z.string(),
    wifPoolId: z.optional(z.string()),
    wifProjectNumber: z.optional(z.string()),
    wifProviderId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      impersonateServiceAccount: "impersonate_service_account",
      wifPoolId: "wif_pool_id",
      wifProjectNumber: "wif_project_number",
      wifProviderId: "wif_provider_id",
    });
  }),
);

export function createPlatformGcpIamCredentialFormToJSON(
  createPlatformGcpIamCredentialForm: CreatePlatformGcpIamCredentialForm,
): string {
  return JSON.stringify(
    CreatePlatformGcpIamCredentialForm$outboundSchema.parse(
      createPlatformGcpIamCredentialForm,
    ),
  );
}
